import React from 'react';
import styled from 'styled-components';
import colors from '../styles/colors';
import buildCarrierStartSmsUri from '../util/buildCarrierStartSmsUri';

const Box = styled.div`
  margin-top: 20px;
  padding: 16px;
  border: 1px solid ${colors.seaGreen};
  border-radius: 5px;
  background: ${colors.cream};
  color: ${colors.grey2};
  font-size: 1.4rem;
  line-height: 1.6;
`;

const Phone = styled.div`
  font-weight: 700;
  font-size: 1.6rem;
  margin: 12px 0;
  color: ${colors.lightBlack};
`;

const SmsLink = styled.a`
  display: block;
  margin: 16px 0 12px 0;
  padding: 14px 16px;
  border-radius: 5px;
  background: ${colors.seaGreen};
  color: ${colors.white};
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  text-decoration: none;

  &:hover,
  &:focus {
    color: ${colors.white};
    opacity: 0.92;
  }
`;

export default function CarrierStartInstructions({
  organizationPhoneNumber,
  carrierStartSmsUri,
}) {
  if (!organizationPhoneNumber) {
    return null;
  }

  const smsUri = carrierStartSmsUri || buildCarrierStartSmsUri(organizationPhoneNumber);

  return (
    <Box>
      <div>
        We could not send a verification text to your phone because messaging is blocked
        at your carrier for this business number.
      </div>
      {smsUri ? (
        <>
          <div style={{ marginTop: '12px' }}>
            Tap below to open Messages with <strong>START</strong> ready to send:
          </div>
          <SmsLink href={smsUri}>SEND START MESSAGE</SmsLink>
        </>
      ) : (
        <div style={{ marginTop: '12px' }}>
          Text <strong>START</strong> to:
        </div>
      )}
      <Phone>{organizationPhoneNumber}</Phone>
      <div>Then return here and tap the button to request your code again.</div>
    </Box>
  );
}
